export default __webpack_public_path__ + "static/media/ridingScooter.44403fe3.svg";